import { WorkflowId } from '@ply-io/ply-front-shared-utilities';

import { api } from './clients';

export const getWorkflow = (wfID: WorkflowId) => api.get(`workflows/${wfID}/`);
